import { useSelector, useDispatch } from "react-redux"
import { setAssessmentExerciseSetRepsCompleted } from "redux/slices/generator"

export default function AssessmentInputLinearDial({ 
    lateralKey,
    phaseIndex,
    exerciseIndex 
}) {

    const dispatch = useDispatch()

    const assessmentExerciseSet = useSelector(state => state.generator.inputs.assessment.phases[phaseIndex].exercises[exerciseIndex].sets[0])

    const OnSliderValueChange = (e) => {

        const payload = {
            lateralKey: lateralKey,
            phaseIndex: phaseIndex,
            exerciseIndex: exerciseIndex,
            setIndex: 0,
            repsCompleted: parseInt(e.target.value)
        }

        dispatch(setAssessmentExerciseSetRepsCompleted(payload))

    }

    if (lateralKey === 'unilateral-left') {

        return (
            <div className='flex-grow flex items-center justify-center gap-x-2'>
                <input
                    type="range"
                    min={0}
                    max={assessmentExerciseSet.reps}
                    value={assessmentExerciseSet.completedSetData.setUnitsCompleted.leftSide}
                    onChange={(e) => OnSliderValueChange(e)}
                    className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-orange-400"
                />
                <div className="w-8 text-center">{assessmentExerciseSet.completedSetData.setUnitsCompleted.leftSide}</div>
            </div>
        )

    }

    if (lateralKey === 'unilateral-right') {

        return (
            <div className='flex-grow flex items-center justify-center gap-x-2'>
                <input
                    type="range"
                    min={0}
                    max={assessmentExerciseSet.reps}
                    value={assessmentExerciseSet.completedSetData.setUnitsCompleted.rightSide}
                    onChange={(e) => OnSliderValueChange(e)}
                    className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-orange-400"
                />
                <div className="w-8 text-center">{assessmentExerciseSet.completedSetData.setUnitsCompleted.rightSide}</div>
            </div>
        )

    }

    if (lateralKey === 'bilateral') {

        return (
            <div className='flex-grow flex items-center justify-center gap-x-2'>
                <input
                    type="range"
                    min={0}
                    max={assessmentExerciseSet.reps}
                    value={assessmentExerciseSet.completedSetData.setUnitsCompleted}
                    onChange={(e) => OnSliderValueChange(e)}
                    className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-orange-400"
                />
                <div className="w-8 text-center">{assessmentExerciseSet.completedSetData.setUnitsCompleted}</div>
            </div>
        )

    }

}